export default "/_next/static/chunks/fonts/Readex Pro Regular-6d1072972cee83a6f1731d61bc7dec6a.ttf";